import { useFlags } from "launchdarkly-react-client-sdk";
import { FEATURE_FLAGS } from "../constants/FeatureFlags";

export function useLdFeatureFlag(flag: FEATURE_FLAGS): boolean {
	const flags = useFlags();
	return Boolean((flags as Record<string, any>)[flag]);
}
